import React, { useEffect, useRef } from "react";
import { artwork, artworkMarkup } from "./artwork";
import mascotStyles from "./mascot.css?inline";

/** The same character as the homepage mascot, still and linked by the header. */
export function MascotLogo() {
  const ref = useRef<HTMLSpanElement | null>(null);
  useEffect(() => {
    const host = ref.current;
    if (!host) return;
    const shadow = host.shadowRoot || host.attachShadow({ mode: "open" });
    const style = document.createElement("style");
    style.textContent = mascotStyles;
    const character = document.createElement("span");
    character.className = "mascot";
    character.setAttribute("style", artwork.style);
    character.innerHTML = artworkMarkup;
    shadow.replaceChildren(style, character);
  }, []);
  return (
    <span
      ref={ref}
      data-mascot-logo
      data-docked="true"
      aria-hidden="true"
      style={{ display: "block", width: 64, height: 64 }}
    />
  );
}
